<script>
    import { onMount } from "svelte";
    import SvelteTable from "svelte-table";

    export let columns,
        rows,
        classNameCell = "py-3",
        classNameThead = "bg-white sticky top-0 h-10 z-[1] text-[#6F726C]",
        classNameTbody = "align-top text-sm text-center text-[#6F726C]",
        classNameRow = "bg-white border-y-2 hover:bg-gray-100",
        classNameRowExpanded = "h-6",
        expandedRowKey = "",
        expandSingle = true,
        showExpandIcon = false,
        clickCellFunc = () => {},
        clickColFunc = () => {},
        clickExpandFunc = () => {},
        grayOutFunction,
        customRowClass,
        customThead = "",
        customTbody = "",
        customRow = "";

    let mouseIsDown = false,
        mouseTimeout = false,
        isMouseClick = true,
        mouseTimer;

    export let tableContainerId;

    window.addEventListener("mousedown", (e) => {
        isMouseClick = true;
        mouseIsDown = true;
        if (mouseTimer) {
            clearTimeout(mouseTimer);
            mouseTimeout = false;
        }
        const targetElement = e.target || e.srcElement;
        if (targetElement && targetElement.tagName) {
            const targetElementTagName = targetElement.tagName.toLowerCase();
            if (targetElementTagName == "select") {
                //this is added for SAFARI browsers to delegate the click, add more tag names if click not working on them
                targetElement.click();
            }
            if (
                targetElementTagName == "input" ||
                targetElementTagName == "svg" ||
                targetElementTagName == "path"
            )
                return;
        }
        mouseTimer = setTimeout(() => {
            isMouseClick = false;
        }, 200);
    });

    const classNameRowFunction = (row) => {
        if (grayOutFunction && grayOutFunction(row))
            return `${classNameRow} ${customRow} opacity-40`;
        else if (customRowClass && customRowClass(row))
            return `${classNameRow} ${customRow} ${customRowClass(row)}`;
        else return `${classNameRow} ${customRow}`;
    };

    window.addEventListener("mouseup", () => {
        clearTimeout(mouseTimer);
        mouseTimeout = false;
        mouseIsDown = false;
    });

    onMount(() => {
        syncHeaderContent();
    });

    const syncHeaderContent = () => {
        const tableContainer = tableContainerId
            ? document.getElementById(tableContainerId)
            : null;
        if (!tableContainer) return;

        const thRow = tableContainer.querySelectorAll("th");

        setTimeout(() => {
            Array.from(thRow).forEach((row) => {
                const content = row.childNodes[0].data;

                const targetColumnDetails = columns.find(
                    (col) => col.title == content,
                );

                if (
                    targetColumnDetails &&
                    targetColumnDetails.hasOwnProperty("headerConfig")
                ) {
                    const {
                        showTooltip,
                        tooltipContent,
                        tooltipClass,
                        htmlContent,
                    } = targetColumnDetails.headerConfig;

                    const span = document.createElement("span");
                    span.innerHTML = htmlContent
                        ? htmlContent
                        : `<i class="fa-regular fa-circle-question"></i>`;
                    span.className = `${showTooltip ? "tooltip tooltip-secondary tooltip-bottom cursor-help" : ""} ${tooltipClass}`;
                    if (tooltipContent && showTooltip)
                        span.setAttribute("data-tip", tooltipContent);
                    row.appendChild(span);
                }
            });
        }, 0);
    };
</script>

<SvelteTable
    {columns}
    bind:rows
    {classNameCell}
    classNameThead={`${classNameThead} ${customThead}`}
    classNameTbody={`${classNameTbody} ${customTbody}`}
    classNameRow={classNameRowFunction}
    {classNameRowExpanded}
    {expandSingle}
    {showExpandIcon}
    rowKey={expandedRowKey}
    on:clickCell={isMouseClick ? clickCellFunc : () => {}}
    on:clickCol={clickColFunc}
    on:clickExpand={clickExpandFunc}
>
    <slot />
</SvelteTable>
